import { HelpText } from '@/components/helpText';
import { Card } from '@/components/ui/smallCard';
import { apiConstants } from '@/config/apiConstants';
import { useChecklistKey } from '@/hooks/useChecklistKey';
import { FormattedMessage } from 'react-intl';

export function AboutContent() {
  return (
    <div>
      <div className="g-prose g-text-sm [&_h3]:g-m-0 [&_h3]:g-text-sm">
        <HelpText identifier={'what-is-a-taxon'} includeTitle />
      </div>
    </div>
  );
}

export function ApiContent({
  id = 'F',
  checklistKey,
}: {
  id?: number | string;
  checklistKey?: string;
}) {
  const defaultChecklistKey = useChecklistKey();
  const datasetKey = checklistKey ?? defaultChecklistKey;
  return (
    <div className="g-text-sm g-prose">
      <div className="g-prose g-text-sm [&_h3]:g-m-0 [&_h3]:g-text-sm">
        <HelpText identifier={'api-access'} includeTitle />
      </div>
      <h4>
        <FormattedMessage id="apiHelp.examples" />
      </h4>
      <Card className="g-p-2 g-mb-2">
        <FormattedMessage id="apiHelp.singleTaxon" /> <br />
        <a href={`${apiConstants.taxonApi}/${datasetKey}/${id}`}>
          {apiConstants.taxonApi}/{datasetKey}/{id}
        </a>
      </Card>
      <Card className="g-p-2 g-mb-2">
        <FormattedMessage id="apiHelp.singleTaxonDetails" /> <br />
        <a href={`${apiConstants.taxonApi}/${datasetKey}/${id}/info`}>
          {apiConstants.taxonApi}/{datasetKey}/{id}/info
        </a>
      </Card>
      <Card className="g-p-2 g-mb-2">
        <FormattedMessage id="apiHelp.searchTaxa" /> <br />
        <a href={`${apiConstants.taxonApi}/search/${datasetKey}?q=Passer`}>
          {apiConstants.taxonApi}/search/{datasetKey}?q=passer
        </a>
      </Card>
    </div>
  );
}
